export const GET_PIN_REQUEST = "GET_PIN_REQUEST";
export const GET_PIN_SUCCESS = "GET_PIN_SUCCESS";
export const GET_PIN_ERROR = "GET_PIN_ERROR";
export const SHOW_BANNER_VALUE = "SHOW_BANNER_VALUE";
